"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomColorsPalette = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ColorBox = require("./ColorBox");
var _utils = require("./utils");
const _excluded = ["selectedColor", "onChange", "customColors", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const S = {
  CustomColorsPalette: _styledComponents.default.div`
        display: flex;
        flex-wrap: wrap;

        ${_ColorBox.SingleColorBox} {
            margin: 3px;
        }
    `
};
function CustomColorsPalette(_ref) {
  let {
      selectedColor,
      onChange,
      customColors = [],
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(S.CustomColorsPalette, rest, customColors.map((color, index) => /*#__PURE__*/_react.default.createElement(_ColorBox.SingleColorBox, {
    key: index,
    color: color,
    onClick: onChange,
    isSelected: selectedColor.compare(color)
  })), children);
}
CustomColorsPalette.propTypes = {
  customColors: _propTypes.default.arrayOf(_propTypes.default.instanceOf(_utils.RGBColor)),
  selectedColor: _propTypes.default.instanceOf(_utils.RGBColor),
  onChange: _propTypes.default.func
};
const StyledCCP = (0, _styledComponents.default)(CustomColorsPalette)``;
exports.CustomColorsPalette = StyledCCP;